// Icons
import WhatsAppIcon from './icons/WhatsAppIcon.svg';
import MessengerIcon from './icons/MessengerIcon.svg';
import InstagramIcon from './icons/InstagramIcon.svg';

export const ActionTypes = {
  UPDATE_NAME: 'UPDATE_NAME',
  UPDATE_RULES: 'UPDATE_RULES',
  UPDATE_CHANNELS: 'UPDATE_CHANNELS',
  UPDATE_OMNICHANNELWIDGET: 'UPDATE_OMNICHANNELWIDGET',
  UPDATE_ACTIVE_STATUS: 'UPDATE_ACTIVE_STATUS',
};

export const CLAUSE_OPTIONS = [
  {
    title: 'And',
    value: 'AND',
  },
  {
    title: 'Or',
    value: 'OR',
  },
];

export const SOCIAL_CHANNELS = {
  ICONS: {
    whatsapp: WhatsAppIcon,
    messenger: MessengerIcon,
    instagram: InstagramIcon,
  },
  TITLE: {
    whatsapp: 'WhatsApp',
    messenger: 'Facebook Messenger',
    instagram: 'Instagram',
  },
  KEYS: {
    whatsapp: 'whatsapp',
    messenger: 'messenger',
    instagram: 'instagram',
  },
};
